import styled from 'styled-components';

const Card = styled.div`
  background: ${props => props.theme.enigmaWhite};
  border-radius: ${props => props.theme.cardBorderRadius};
  border: ${props => props.theme.borderLt};
  box-shadow: ${props => (props.shadow ? props.theme.defaultShadow : 'none')};
  @media ${props => props.theme.device.portrait} {
    max-width: 100%;
  }
`;

Card.defaultProps = {
  shadow: true,
};

export default Card;
